import { render, staticRenderFns } from "./zDialogo2.vue?vue&type=template&id=0d1f54aa&scoped=true&"
import script from "./zDialogo2.vue?vue&type=script&lang=js&"
export * from "./zDialogo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f54aa",
  null
  
)

export default component.exports